import { useNavigate, } from "react-router-dom";
import { Box, Button, HStack, Icon, Text, } from "@chakra-ui/react";
import { RoutesMap, } from "../../../../routes.tsx";
import { ChevronLeftIcon, } from "@heroicons/react/24/outline";

export function QrPageHeader() {
  const navigate = useNavigate();

  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      w="100%"
      zIndex={200}
      px={4}
      pt={4}
      pb={2}
      pointerEvents="auto"
    >
      <HStack alignItems="center" spacing={4}>
        <Box>
          <Button
            onClick={() => {
              navigate(RoutesMap.index,);
            }}
            rounded="full"
            variant="ghost"
          >
            <Icon as={ChevronLeftIcon} boxSize={6} color="white" />
          </Button>
        </Box>

        <Box flex={1}>
          <Text align="center" color="white">
            Сканирование QR
          </Text>
        </Box>

        <Box boxSize={12} />
      </HStack>
    </Box>
  );
}
